<template>
<div class="animated fadeIn manage-store">
  <div class="card dash-field">
    <div class="row m-0">
      <div class="card-body col-md-8">
        <h3>{{$t('DPSFOR')}}: {{moment(date).day(0).format('ddd-MMM/DD/YY')}}</h3>
      </div>
      <div class="col-md-4 m-auto">
        <b-form-select :options="users.root" v-model="userId" value-field="userId" text-field="name" :disabled="(globals.groupId != 4) ? false : true"></b-form-select>
      </div>
    </div>
  </div>
  <div class="card">
    <div class="card-body">
      <div class="row mb-2">
        <div class="col-sm-5">
          <button type="button" class="btn btn-secondary" @click="getDateObject('previous')">
            <!-- icon icon="plus"></icon --> {{$t('PREVIOUSWEEK')}}
          </button>
        </div>
        <div class="col-sm-2">
          <div class="row">
            <icon icon="calendar-check" @click="openCalendat()" class="mt-2 mr-2"></icon>
            <datepicker ref="datepicker" name="startDate" v-model="calendarDate"></datepicker>
          </div>
        </div>
        <div class="col-sm-5">
          <button type="button" class="btn btn-secondary float-right" @click="getDateObject('next')">
            <!-- icon icon="plus"></icon --> {{$t('NEXTWEEK')}}
          </button>
        </div>
      </div>
      <div class="clear20">&nbsp;</div>
      <div class="row mb-2">
        <div class="col-sm-12">
          <table class="table table-foursight table-striped table-hover table-sm">
            <thead>
              <tr>
                <th></th>
                <template v-for="item in dates">
                  <th>{{moment(item).format('ddd-MMM/DD/YY')}}</th>
                </template>
                <th>{{$t('TOTAL')}}</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(item, key) in dps">
                <tr aria-rowindex="1" class=" table-ellipsis">
                  <td>{{$t(key.toUpperCase())}}</td>
                  <template v-for="(itemSec, keySec) in item">
                    <td @dblclick="showModal(keySec, key)" 
                        :style='(key == "actualSales" || key == "numberItems" || key == "numberTransactions") ? "color: blue; cursor: pointer;" : ""'
                        :class="(key == 'actualSales') ? ((dps['actualSales'][keySec] >= dps['goldStar'][keySec]) ? 'table-statistics-above-backgrouncolor' : 'table-statistics-under-backgrouncolor') : ''" >
                        {{itemSec}}
                    </td>
                  </template>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <b-modal ref="formmodal" :title="$t('DPSFORM')" ok-title="submit" hide-footer no-close-on-backdrop>
      <div class="d-block">
        <dpsform v-bind:formData="formData" v-bind:formError="formError"></dpsform>
      </div>
      <div class="text-right">
        <b-btn class="mt-3" variant="secondary-trans mr-4" @click="hideModal">{{$t('CANCEL')}}</b-btn>
        <b-btn class="mt-3" variant="primary" @click="submitData(formData)">{{$t('SAVE')}}</b-btn>
      </div>
    </b-modal>
  </div>
</div>
</template>

<script>
import
{
  mapActions,
  mapGetters
}
from 'vuex'
import moment from 'moment';

import DpsApi from '@/api/salesportal/Dps'
import StoreApi from '@/api/salesportal/Store'
import DpsForm from './Form'

export default
{
  name: 'ScheduleWin',
  props: ['storeId', 'tabIndex'],
  components:
  {
    dpsform: DpsForm
  },
  data: function()
  {
    return {
      date: moment().format('YYYY-MM-DD'),
      calendarDate: null,
      dates: [],
      userId: null,
      dps:
      {},
      users:
      {},
      formError:
      {},
      formData:
      {
        date: null,
        userId: null,
        actualSales: 0,
        numberTransactions: 0,
        numberItems: 0
      }
    }
  },
  async created()
  {
    var me = this;
    //me.setWeek();
    //await me.getUsers()
  },
  methods:
  {
    openCalendat()
    {
      var me = this;
      me.$refs.datepicker.$children[0].$emit('showCalendar')
    },
    getDateObject(item)
    {
      var me = this;

      if (typeof item !== 'undefined' && item == 'previous')
      {
        me.date = moment(me.date).subtract(7, 'days').format('YYYY-MM-DD');
      }
      else if (typeof item !== 'undefined' && item == 'next')
      {
        me.date = moment(me.date).add(7, 'days').format('YYYY-MM-DD');
      }
    },
    setWeek()
    {
      var me = this;
      me.dates = [];
      for (var i = 0; i < 7; i++)
      {
        me.dates.push(moment(me.date).day(i).format('YYYY-MM-DD'));
      }
    },
    async getUsers()
    {
      var me = this;
      try
      {
        var data = await StoreApi.selectUsers(
        {
          storeId: me.storeId,
          userStatus: 'active'
        });
        if (data.error && data.error == true)
        {
          me.$notify.notice(data);
          me.loading = false;
          return;
        }

        me.users = data;
        var userId = null;
        for(var user of data.root)
        {
          if(user.userId == me.globals.userId) userId = user.userId
        }
        me.userId = (userId == null) ? me.users.root[0].userId : userId
      }
      catch (e)
      {
        me.$notify.notice(e);
      }
    },
    async getDpsData()
    {
      var me = this;
      try
      {
        var data = await DpsApi.selectDps(
        {
          date: me.date,
          userId: me.userId,
          storeId: me.storeId
        });
        if (data.error && data.error == true)
        {
          me.$notify.notice(data);
          me.loading = false;
          return;
        }

        me.dps = data.root;
      }
      catch (e)
      {
        me.$notify.notice(e);
      }
    },
    showModal(key, id)
    {
      var me = this;
      if (id == "actualSales" || id == "numberItems" || id == "numberTransactions")
      {
        var actualSales = me.dps.actualSales[key];
        var numberTransactions = me.dps.numberTransactions[key];
        var numberItems = me.dps.numberItems[key];

        me.formData.date = key;
        me.formData.userId = me.userId;
        me.formData.actualSales = (actualSales == undefined) ? 0 : actualSales;
        me.formData.numberTransactions = (numberTransactions == undefined) ? 0 : numberTransactions;
        me.formData.numberItems = (numberItems == undefined) ? 0 : numberItems;


        this.$refs.formmodal.show();
      }
      return;
    },
    async submitData(item)
    {
      var me = this;
      try
      {
        var data = await DpsApi.setDps(item);
        if (data.error)
        {
          me.$notify.notice(data);
          me.formError = data;
        }
        else
        {
          me.$notify.notice(data);
          me.hideModal();
          await me.getDpsData();
        }
      }
      catch (e)
      {
        me.$notify.notice(e);
      }
    },
    hideModal()
    {
      var me = this;
      this.$refs.formmodal.hide();

      me.formData = {
        date: null,
        userId: null,
        actualSales: 0,
        numberTransactions: 0,
        numberItems: 0
      }
    }
  },
  watch:
  {
    date(val)
    {
      var me = this;
      me.setWeek();
      me.getDpsData();
    },
    calendarDate(val)
    {
      var me = this;
      me.date = moment(val).format('YYYY-MM-DD');
    },
    userId(val)
    {
      var me = this;
      me.getDpsData();
    },
    async tabIndex(val)
    {
      var me = this;
      try
      {
        var tabKey = 5;
        if(me.globals.groupId == 4)
        {
          tabKey=2
        }
        
        if (val == tabKey)
        {
          await me.setWeek();
          await me.getUsers();
        }
      }
      catch (error)
      {
        me.$notify.notice(e);
      }
    }
  },
  computed:
  {
    ...mapGetters([
      'globals'
    ])
  }
}
</script>
